import { Link, ReferenceField, TextField, useRecordContext } from "react-admin";

export const CounselorReferenceField = () => {
  const record = useRecordContext();
  const openCounselorLink = false;
  if (openCounselorLink) {
    return (
      <Link to={`/counselors/${record.counselor_id}`}>
        <ReferenceField source="counselor_id" reference="counselors">
          {/* <TextField source="counselor_name" /> */}
          <TextField source="counselor_agency" />
        </ReferenceField>
      </Link>
    );
  } else {
    return (
      <ReferenceField source="counselor_id" reference="counselors">
        {/* <TextField source="counselor_name" /> */}
        <TextField source="counselor_agency" />
      </ReferenceField>
    );
  }
};
